@if (pageReady) {
  <main class="gs-page">
    <div class="register-page">
      <div
        class="gradient-container register-section"
        [style]="'background:url(' + pageLabels.gradientBackgroundUrl + ')'"
      >
        <div class="register-form-container">
          <img [src]="pageLabels.gasSouthLogoLg" alt="Gas South 20 Years Logo" class="logo-image" />
          <app-notification [pageName]="pageName"></app-notification>
          <h1 class="register-account-header">{{ pageLabels.registerHeaderText }}</h1>
          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="register-form">
            <mat-radio-group
              [attr.aria-label]="pageLabels.customerClassRadioButtonAriaLabel"
              class="gs-radio-button horizontal-radio-group"
              color="primary"
              formControlName="CustomerClassRadio"
            >
              <mat-radio-button value="RES" checked="true" (change)="updateForm('RES')">
                {{ pageLabels.residentialRadioButtonLabel }}
              </mat-radio-button>
              <mat-radio-button value="SMLCOM" (change)="updateForm('SMLCOM')">
                {{ pageLabels.businessRadioButtonLabel }}
              </mat-radio-button>
            </mat-radio-group>
            <mat-form-field class="register-container" appearance="outline" subscriptSizing="dynamic">
              <mat-label id="accountNumberLabel">{{ pageLabels.registerAccountNumberLabel }}</mat-label>
              <input
                matInput
                class="custom-input"
                formControlName="accountNumber"
                id="acctNumber"
                aria-labelledby="accountNumberLabel accountNumberError ConfirmAcctNumMinLengthErr acctNumInvalidErr"
                maxlength="10"
              />
              @if (registerForm.get("accountNumber")?.hasError("required")) {
                <mat-error id="accountNumberError">{{ pageLabels.accountNumberError }}</mat-error>
              } @else if (registerForm.get("accountNumber")?.hasError("minlength")) {
                <mat-error id="ConfirmAcctNumMinLengthErr">{{ pageLabels.accountNumberTenDigitError }}</mat-error>
              } @else if (registerForm.get("accountNumber")?.hasError("invalidAccount")) {
                <mat-error id="acctNumInvalidErr">{{ pageLabels.accountNumberTenDigitError }}</mat-error>
              }
            </mat-form-field>
            @if (radioSelected === "RES") {
              <mat-form-field class="register-container" appearance="outline" subscriptSizing="dynamic">
                <mat-label id="ssnPinLabel">{{ pageLabels.registerSsnValue }}</mat-label>
                <input
                  matInput
                  class="custom-input"
                  formControlName="ssnPin"
                  id="ssnPin"
                  data-private
                  aria-labelledby="ssnPinLabel ssnPinNumberError ssnPinNumMinLengthErr ssnPinNumInvalidErr"
                  maxlength="6"
                />
                @if (registerForm.get("ssnPin")?.hasError("required")) {
                  <mat-error id="ssnPinNumberError">{{ pageLabels.accountSsnError }}</mat-error>
                } @else if (registerForm.get("ssnPin")?.hasError("minlength")) {
                  <mat-error id="ssnPinNumMinLengthErr">{{ pageLabels.accountSsnError }}</mat-error>
                } @else if (registerForm.get("ssnPin")?.hasError("invalidSSNPin")) {
                  <mat-error id="ssnPinNumInvalidErr">{{ pageLabels.accountSsnError }}</mat-error>
                }
              </mat-form-field>
            } @else {
              <mat-form-field class="register-container" appearance="outline" subscriptSizing="dynamic">
                <mat-label id="postalCodeLabel">{{ pageLabels.mailingAddressZipCodeText }}</mat-label>
                <input
                  matInput
                  class="custom-input"
                  formControlName="postalCode"
                  id="postalCode"
                  aria-labelledby="postalCodeLabel postalCodeReqError postalCodeNumMinLengthErr postalCodeInvalid"
                  maxlength="5"
                />
                @if (registerForm.get("postalCode")?.hasError("required")) {
                  <mat-error id="postalCodeReqError">{{ pageLabels.mailingZipCodeError }}</mat-error>
                } @else if (registerForm.get("postalCode")?.hasError("minlength")) {
                  <mat-error id="postalCodeNumMinLengthErr">{{ pageLabels.mailingZipCodeError }}</mat-error>
                } @else if (registerForm.get("postalCode")?.hasError("invalidZipCode")) {
                  <mat-error id="postalCodeInvalid">{{ pageLabels.invalidZipCodeError }}</mat-error>
                }
              </mat-form-field>
            }
            <button mat-flat-button class="gs-form-button-primary continue-button" color="primary">
              {{ pageLabels.registerText }}
            </button>
          </form>
          <p class="help-text" [innerHTML]="pageLabels.helpText"></p>
          <a class="login-link" (click)="goToLogin()" href>{{ pageLabels.backLinkText }}</a>
        </div>
      </div>
      <div class="account-benefits register-section">
        <gs-icon-list [ListData]="pageLabels.accountBenefitsList" (DebugData)="logDebug($event)"></gs-icon-list>
      </div>
    </div>
  </main>
}
